import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { meetingSDK } from "unifiedring-sdk";
import store from "../../../../context/store/store";
import { callMainPageInterface } from "../../../../models/callModel";
import { getMeetingId, uuidv4 } from "../../../../base/meetingService/utils/meetingServices";
import moment from "moment";
import { getMeetingByDate, getMeetingLists, updateMeetingRead } from "../../../../base/meetingService/apiService";
import { storeMeetingPage, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import { profileDetails, UserDetails } from "../../../../models/model";
import { toastInformation } from "../../../../base/callService/common";
import { Types } from "../../../../context/action/action";


type letmeetDetail = {
  title: string;
  password: string;
  meeting_id: string;
  participants: Array<any>;
  personal_meeting_id: string;
  is_host_myaudio: boolean;
  is_host_myvideo:boolean;
  is_use_personal_meeting_id: boolean;
  is_participant_waiting_room:boolean;
  is_participant_video:boolean;
}

type letsMeetNowState = {
  isModalVisible: boolean;
  allContacts: Array<any>;
  meetingDetail: letmeetDetail;
  searchKey: string;
  buttonEnableStatus: boolean;
  pwdError:boolean;
  pwdText:string;
}

type letsMeetNowProps = { leetsMeetNowStatus: Function; meetDetails?:any }

let randomId = uuidv4();

export default function LetsMeetNow({ leetsMeetNowStatus,meetDetails }: letsMeetNowProps) {
  const profileUserDetails:  profileDetails = useSelector((state: any) => state.profileReducer);
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  let { workContacts } = contactReducer;
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { getListInput } = meetingReducer;
  let {videoprofileData} = profileUserDetails;
let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  const [getData, setData] = useState<letsMeetNowState>({
    isModalVisible: true,
    allContacts: workContacts,
    meetingDetail: {
      participants: [],
      // title:   'Meet now '+  moment(new Date()).format('DD MMM,YYYY HH:mm:ss A'),
      title: `Quick Meeting with ${loggedUserDetails.caller_id.charAt(0).toUpperCase() + loggedUserDetails.caller_id.slice(1)}`,
      meeting_id: getMeetingId(),
      is_host_myaudio: meetDetails?.isAudio,
      is_host_myvideo:meetDetails?.isVideo,
      is_participant_video:true,
      password: meetDetails?.isPersonalId?videoprofileData?.security.passcode:"" ,
      is_use_personal_meeting_id: meetDetails?.isPersonalId,
      is_participant_waiting_room: false,//videoprofileData?.security.wating_room !== undefined? videoprofileData?.security.wating_room:false,
      personal_meeting_id: getMeetingId()
    },
    buttonEnableStatus:false,
    searchKey:'',
    pwdError:false,
    pwdText:""
  });
  
  let { meetingDetail } = getData
  let { personal_meeting_id } = meetingDetail;

 
  const handleOk = () => {
     setData({ ...getData,buttonEnableStatus:true });
    if ((meetingDetail.title).trim() === "") {
      meetingDetail.title = `Quick meeting with ${loggedUserDetails.caller_id.toUpperCase()}`
    }
    
      let userInfo = store.getState().loginReducer.userdetails || [];
      let hostInfo: any = {
        email: userInfo.Email,
        ext: userInfo.ext,
        name: userInfo.caller_id,
        profile_img: userInfo.profile_url,
        roletype: 1,
        sipid: (userInfo.sip_login_id)?.toString(),
        user_type:'company'
      };
      meetingDetail.participants.push(hostInfo);
     // let id = meetingDetail.is_use_personal_meeting_id ? personal_meeting_id : randomId;
      meetingDetail['meeting_id'] = meetingDetail.is_use_personal_meeting_id ? personal_meeting_id : randomId;
      
       return new Promise((resolve, reject) => {
       new meetingSDK.MeetingRestService().meetNow(meetingDetail).then((result: any) => {
        if (result?.statusCode === 200) {
          toastInformation("Meeting created successfully", "success");
          store.dispatch({
            type: Types.VIDEOMEET_COUNT_STATUS,
            payload: {
              meetingCountStatus:true
            }
          })
          updateMeetingRead(result?.uuid);
          setData({ ...getData, isModalVisible: false,buttonEnableStatus:true });
          leetsMeetNowStatus(false);
          let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = getListInput.filter;
        data.searchText = '';
        data.sort = getListInput.sort;
        getMeetingLists(data);
          getMeetingByDate(moment(new Date()).format("YYYY-MM-DD"));
          new meetingSDK.MeetingRestService().getMeetingsByUuid(result.uuid).then((res:any) => {
            if (res?.statusCode === 200) { 
              //  calendarType(res.result,res.result.invite_url);
              storeMeetingPage(res.result);
              storeWindowState("meetingDetails");
            }
          })
    let replaced_url:any= result.inviteUrl?.includes("stagemeet") ? `${result.inviteUrl }?type=meetnow`: `${result.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=meetnow`;
     window.open(replaced_url, '_blank');
        }
        else { 
           setData({ ...getData,buttonEnableStatus:false,pwdError:true,pwdText:result.message });
        }
      })
         .catch((err: any) => {
           console.log("err>>***");
          // toastInformation(err, "failure");
          setData({ ...getData,buttonEnableStatus:false });
          // console.log("error is", err);
        });
     }) 
 
  };

  // const searchContact = (e: string) => {
  //   let searchName = e.toLowerCase();
  //   if(searchName !== "") {
  //     let filtered = _.filter(workContacts, function(name:any) {
  //       return  name.caller_id?.toLowerCase().includes(searchName) ||
  //       name.ext?.toString().includes(searchName) ||  name.team_name?.includes(searchName);
  //     });
  //     setData({ ...getData, allContacts: filtered, searchKey:searchName });
  //   }
  //   else{ setData({...getData,allContacts:workContacts,searchKey:searchName}); }
  // };

  // const handleCancel = () => {
  //   setData({ ...getData, isModalVisible: false });
  //   leetsMeetNowStatus(false);
  // };

  // const personalIdOnchange = (value: any) => {
  //   setData({
  //     ...getData, meetingDetail: {
  //       ...meetingDetail, is_use_personal_meeting_id: value,
  //       meeting_id:(value) ? personal_meeting_id : randomId
  //     }
  //   });
  // };

  // const meetingTextBoxChanges = (e: any) => {
  //   setData({ ...getData, meetingDetail: { ...meetingDetail, title: e.target.value } });
  // };


  // const selectBoxOnchange = (val: any, obj: any) => {

  //   try {
  //     if (val.length !== 0) {
  //       let participantList: any = [];
  //       val.map((data: any) => {
  //         let listData = JSON.parse(data);
        
  //         let list = {
  //           email: listData.email_id,
  //           ext: listData.ext,
  //           name: listData.caller_id,
  //           profile_img:listData.ImageURL,
  //           roletype: 3,
  //           sipid: (listData.sip_login_id)?.toString(),
  //           user_type:'company'
  //         };
  
  //         participantList.push(list);
  //         setData({ ...getData,allContacts:workContacts,searchKey:"", meetingDetail: { ...meetingDetail, participants: participantList  } });
  //       });
  //     }
  //     else { setData({ ...getData,allContacts:workContacts,searchKey:"", meetingDetail: { ...meetingDetail, participants: [] } }); }
  //   } catch (error) {
  //     console.log("selectBoxOnchange >>>>>", error);
  //   }

  // };

  // const meetingPasswordBoxChanges = (e: any) => {
  //   setData({ ...getData, meetingDetail: { ...meetingDetail, password: e.target.value } });
  // };

  useEffect(() => {
    handleOk();
    return () => {
      randomId = uuidv4();
      setData({ ...getData, buttonEnableStatus: false });
    }
}, [meetDetails?.isMeetNow])

  return (
    <>
      {/* <Modal visible={isModalVisible} className={`${styles.meetNow} ${"meetNowmodal"} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={handleCancel} />
        <h2 className="modalTitle">Meet Now</h2>
        <div>Meeting Title</div>
        <div className={styles.meetTitleBox}>
          <URInput placeHolder="Enter meeting title" name="" maxLength={80} className={`hoverbdrBlue meetingInput ${styles.normalinput}`}
            value={meetingDetail.title}
            onChange={meetingTextBoxChanges}
          />
          <span className={styles.inputright}>{80 - getData.meetingDetail.title.length}</span>
        </div>
        <div className={styles.meetingIDbody}>
          <div className={!meetingDetail.is_use_personal_meeting_id ? `${styles.disabled} ${styles.idDetails}` : `${styles.idDetails}`}>
            Personal Meeting ID <div>
              <div className={styles.meetingRow}><b>({meetingDetail.personal_meeting_id})</b>
                <Switch size="small" checked={meetingDetail.is_use_personal_meeting_id}
                  onChange={personalIdOnchange} className={styles.mID} /></div>
              </div>

          </div>

            <div className={meetingDetail.is_use_personal_meeting_id ? `${styles.disabled} ${styles.meetingRow}` : `${styles.meetingRow}`}>Random Meeting ID {randomId}
            <div className={`${styles.disabled} ${styles.random}`}>A randomly generated ID is more secure</div>
           
            
            </div>
          <div className={styles.meetingRow}>Password : 
          
          <URInput placeHolder="Enter password" name="" maxLength={16} className={`hoverbdrBlue passwordInput ${styles.normalinput}`}
            value={meetingDetail.password}
              onChange={meetingPasswordBoxChanges} />
            
             {getData.pwdError && <p className="error joinmeeterror">{getData.pwdText}</p>}
          </div>
  
        </div>
        <label>Add Participants</label>

        <div className={styles.insideicon}>
         {meetingDetail.participants.length === 0 && <img src={taskimg2} alt="" />}
          <Select
            mode='multiple'
            style={{ width: '100%' }}
            placeholder="Search for extension to member"
            className={meetingDetail.participants.length === 0 ? "newselects taskcreations customdropbox ":"newselects taskcreations customdropbox inputselectlftnone"}
            dropdownClassName="newChatSel"
            showSearch={true}
            filterOption={false}
            onChange={selectBoxOnchange}
            onSearch={searchContact}>
            {allContacts?.map((contactName: any, index: any) => {
              let highlighted: any = searchHighlight(contactName, searchKey);
              return  <option  key={index} value={JSON.stringify(contactName)} >
                <div className="dropdowndesign">
                <div className="usergroupss">
                  <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt=""  className={styles.imgSelected}/>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                </div>
                {searchKey !== '' ?
                <div className="names">{ (highlighted?.middleMsg !== "") ?(<>{ highlighted?.firstMsg}
                  <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                  {highlighted?.lastMsg}</>) :
                    (<>{contactName?.caller_id}</>)}</div> :
                    <div className="names">{contactName.caller_id }</div> }

                 
                  <div className="ext">{contactName.ext }</div>
                </div>
              </option>;
            })}
          </Select>
        </div>
        <div className={styles.footersection}>
          <URButton className='urButton buttonWhite mr8' onClick={handleCancel} name="Cancel"></URButton>
          <URButton className='urButton buttonBlue' onClick={handleOk} name="Start Meeting" disabled={getData.buttonEnableStatus ? true : false}></URButton>
        </div>
      </Modal> */}
    </>
  );
};

